import axiosBasicInstance from '../axiosConfig';
const addCompany = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/add-company', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const addCompanyAuthentication = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/company/authentication', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getCompany = async (companyId, langId) => {
   try {
      // const response = await axiosBasicInstance.get(`/management/company/${companyId}`);
      const response = await axiosBasicInstance.get(`/management/company/${langId}/${companyId}`);
      return response;
   } catch (error) {
      throw error;
   }
};

const switchCompany = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/switch-company', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const checkCompany = async (taxCode, langId) => {
   try {
      // const response = await axiosBasicInstance.get(`/management/check-company-by-tax-code/${taxCode}`);
      const response = await axiosBasicInstance.get(`/management/check-company-by-tax-code/${langId}/${taxCode}`);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateCompany = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/update-company', data);
      return response;
   } catch (error) {
      throw error;
   }
};


export { addCompany, addCompanyAuthentication, getCompany, switchCompany, checkCompany, updateCompany};
